import './site/site.css'
import { getLocale, setLocale } from './brand/index.js'
import { renderSite, pageForPath } from './site/pages.js'
import { platform } from './platform/bridge.js'

const url = new URL(window.location.href)
const language = url.searchParams.get('lang')
if (language === 'en' || language === 'ru') setLocale(language)
const playing = /^\/play(?:\/|$)/.test(url.pathname) || url.searchParams.has('seed') || url.searchParams.has('mode')
const root = document.getElementById('app')
if (!root) throw new Error('Game root missing')

if (playing) {
  document.body.classList.add('playing')
  document.documentElement.lang = getLocale()
  document.getElementById('site')?.remove()
  root.innerHTML = `<div class="boot"><span class="boot-mark">MR</span><p>${getLocale() === 'ru' ? 'Подготовка арены' : 'Preparing the arena'}…</p></div>`
  platform.loadingStart()
  import('./index.js').then(({ mountGame }) => {
    root.innerHTML = ''
    const game = mountGame(root)
    ;(window as unknown as { __mechrulez: unknown }).__mechrulez = game
    platform.loadingStop()
    const update = () => {
      const s = game.store.get()
      const active = !document.hidden && game.shell.get().view === 'match' && !['matchOver', 'result', 'waiting'].includes(s.screen)
      active ? platform.gameplayStart() : platform.gameplayStop()
    }
    const unsubscribe = game.store.subscribe(update)
    const unsubscribeShell = game.shell.subscribe(update)
    document.addEventListener('visibilitychange', update)
    update()
    window.addEventListener('pagehide', () => { unsubscribe(); unsubscribeShell(); platform.gameplayStop() }, { once: true })
  }).catch((error: unknown) => {
    console.error(error)
    platform.loadingStop()
    const ru = getLocale() === 'ru'
    root.innerHTML = `<div class="boot"><h1>${ru ? 'Арена недоступна' : 'Arena unavailable'}</h1><p>${ru ? 'Для игры нужен браузер с WebGL2. Обновите страницу или попробуйте другой браузер.' : 'A browser with WebGL2 is required. Reload or try another browser.'}</p><a class="site-button" href="${ru ? '/ru/' : '/'}">${ru ? 'На главную' : 'Back to home'}</a></div>`
  })
} else {
  const page = pageForPath(url.pathname)
  const site = document.getElementById('site')!
  if (!page) site.innerHTML = '<h1>404</h1><a href="/">MechaRulez</a>'
  else {
    if (!site.querySelector('[data-site-page]')) site.innerHTML = renderSite(page)
    document.documentElement.lang = page.locale
    document.querySelectorAll<HTMLAnchorElement>('[data-language]').forEach(link => link.addEventListener('click', () => setLocale(link.dataset.language as 'en' | 'ru')))
  }
}
